var _defs, _style, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGreenTick(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 51 51",
    width: 51,
    height: 51,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "cp1"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m-1576-1062h1920v2097h-1920z"
  })), /*#__PURE__*/React.createElement("image", {
    width: 51,
    height: 51,
    id: "img1",
    href: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADMAAAAzCAMAAAANf8AYAAAAAXNSR0IB2cksfwAAAO1QTFRFNc4MNc4MNc4MNc4MNc4MNc4MNc4MNc4MNc4MNc4MNc4MNc4MNc4MNc4MNc4MNc4MNc4MNc4MNc4MNc4MNc4MNc4MNc4MNc4MNc4MNc4MNc4MNc4MNc4MNc4MNc4MNc4MW9RFzO7I/Pv8a9dYNc4MNc4MNc4M8/jzlOCJNc4MNc4MrOWkNc4MedpqNc4MSdEtoOKWNc4MNc4Mwuu8Nc4M4PPeNc4MNc4MNc4MNc4Mt+iwNc4M1/DTNc4M6vboh916Nc4MNc4MNc4MNc4MNc4MNc4MNc4MNc4MNc4MNc4MNc4MNc4MNc4MNc4MNc4M+AmepQAAAE90Uk5TAAhCfqjO5fD/CVu19xCA6wJn7e4lyVXxd/6Mi3hXKPX/////ygNo//9uD/95/+r//1ay/7P/rdDR6f/5//L//4ERaW/LWH3vgly3+EN/RDyWcPYAAAH2SURBVHicndbZVsIwEADQgIDDjoIUFZWmSOuCgCgqgoD7/v+f46Qt0NAkjcxTmpPbZZJmQkgoYvGNRDK1CZupZGIjHgsPWI10JpuDYOSymbRS5AtFCEexkJeK0ta2QLAob5XEpLIjESx2KiJSNRQEwKiGSW1XSQB2a6tkL0Kw2OdJXYMA1IPkIOrF/NcLfNPhkQZoNDARi+yVVEmeC5NSC6B57JtWNLFsSqmDjROPnMpmfxkOZXGGrfKpa841CW2z9jkjsQtNYnfYRZH9HFVNQrveZQ/NpSbp+9dX+Go5pQgRyKVJfGWMZXoJWiHXy644KYhu2wiRznJIgQz4p3hDHAWBAbnhjEkXsycjcEvuOOMPGioIpMi9yIyCxLb4Tx4TEBkbm0MJARA/B5PQl5Kx+HsofZAS/B4+byPKh4Bg3gZK44QJzg+/DsxoguuAX29n0QTXG7+unWiC65pcBTusSML+H9LjeuY5pnZbTNz/NMaVqcl8fgRJdsPdD8iU62u7TzI7EgJTd6+a8ftbpzsaTWQCyjNvU3yUjgjH0z/2az+e5/u1Xl1gYQSq6otm/ekFi9arluHq3Fr1dK26vdb5AM8hTQVpCs8hOE+tskS8tSTnHYz8VHiuep9JBYv0xydfXL4+P9TnN499/+A50QADz4k/vwLwB2EGd/EMIkZXAAAAAElFTkSuQmCC"
  }))), _style || (_style = /*#__PURE__*/React.createElement("style", null)), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#cp1)"
  }, /*#__PURE__*/React.createElement("use", {
    href: "#img1",
    x: 0,
    y: 0
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGreenTick);
export default __webpack_public_path__ + "static/media/green-tick.f94758a08e955e687180f7ec1b1bd9a6.svg";
export { ForwardRef as ReactComponent };